import { useTranslation } from "react-i18next";
import step1Img from "../../../../assets/instruction/verify-visa-info-guide/step1.jpg";
import step2Img from "../../../../assets/instruction/verify-visa-info-guide/step2.jpg";

const VerifyVisaInfoGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 py-6">
      <p>
        <span className="text-primary-blue font-bold">
          {t("instructions.step", { number: "1" })}:{" "}
        </span>
        {t("instructions.instructions_list.verify_info_guide.content.step1")}
      </p>
      <img src={step1Img} alt="Step 1" className="w-full" />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "2" })}:{" "}
        </span>
        {t("instructions.instructions_list.verify_info_guide.content.step2")}
      </p>
      <img src={step2Img} alt="Step 2" className="w-full" />
    </div>
  );
};

export default VerifyVisaInfoGuide;
